import { PageWrapper } from 'ui/redesign/PageWrapper';
import TabGroup from 'ui/TabGroup';
import { TabGroupProps } from './types';
import { MyExecutors } from './MyExecutors';
import { Invites } from './Invites';
import { useAppSelector } from 'hooks/useAppSelector';
import { getPermissions } from 'reduxStore/reducers/ProfileSlice/selectors/getPermissions';
import { ProfilePermissions } from 'reduxStore/reducers/ProfileSlice/types';

export const ExecutorsPage = () => {
  const permissions = useAppSelector(getPermissions);

  const tabItems: TabGroupProps['tabItems'] = [
    permissions.includes(ProfilePermissions.Document_ReadExecutors) && {
      title: 'Мои исполнители',
    },
    permissions.includes(ProfilePermissions.Invitation_InvitationsCooperate_Read) && {
      title: 'Приглашения',
    },
  ].filter(Boolean) as TabGroupProps['tabItems'];

  const tabContent = [
    permissions.includes(ProfilePermissions.Document_ReadExecutors) && (
      <MyExecutors key="myExecutors" />
    ),
    permissions.includes(ProfilePermissions.Invitation_InvitationsCooperate_Read) && (
      <Invites key="invites" />
    ),
  ].filter(Boolean) as React.ReactElement[];

  return (
    <PageWrapper title="Исполнители">
      <section className="flex flex-col">
        <div className="flex flex-col">
          <TabGroup tabItems={tabItems} tabPanelsContent={tabContent} />
        </div>
      </section>
    </PageWrapper>
  );
};
